import React from 'react';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import cautionSolid from '@starbucks-web/pattern-library/lib/icons/caution-solid';

import styles from './styles.cssm';

const Alert = ({ errorHeading, errorMessage }) => (
  <div
    className={`${styles.alert} relative borderRadius-sm p3 my3`}
    role="alert"
  >
    <Icon className="ml3 color-red float-right" path={cautionSolid} />
    <Heading size="md" tagName="h2">
      {errorHeading}
    </Heading>
    <p className="mt2">{errorMessage}</p>
  </div>
);

export default Alert;
